/** @format */
import * as angular from 'angular';

locationModel.$inject = ['DS'];

export const locationModelModule = 'sis-components.model.location';

angular.module(locationModelModule, ['js-data']).factory('locationJSDataModel', locationModel);

function locationModel(DS) {
    return DS.defineResource({
        idAttribute: 'id',
        name: 'location',
        endpoint: '/kori/api/locations',
    });
}
